import { FILM_CONFIG } from "../film/filmConfig";

export const MISSION_CONFIG = {
  ...FILM_CONFIG,
  workshopType: 'mission',
  heading: 'AI Mission',
  slideshowUrl: '/ai-mission-slideshow',
  footerBlurb: 'Created by participants using leading AI models',
  nodePageClass: 'intro-page-background-mission',

  storageKeys: {
    node: 'mission-nn-node',
    workshopId: 'mission-workshop-id',
    password: 'mission-frontend-password',
    gptMessages: 'mission-gpt-messages',
    dalleOutputs: 'mission-dalle-outputs',
    musicgenUrls: 'mission-musicgen-urls',
    slide: 'mission-slide',
    readyForPoster: 'mission-ready-for-poster',
    imageGenerationStarted: 'mission-image-generation-started',
    voices: 'mission-voices',
    synth: 'mission-synth',
    missionData: 'mission-mission-data',
  },

  slideshow: {
    title: 'AI Mission - Slideshow',
  },
};
